/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Zpět na domovskou stránku`
};

const da_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Tilbage til forsiden`
};

const de_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Zurück zur Startseite`
};

const en_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Back to homepage`
};

const es_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Volver al inicio`
};

const fr_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Retour à l'accueil`
};

const hu_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Vissza a kezdőlapra`
};

const it_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Torna alla home`
};

const nl_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Terug naar home`
};

const pl_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Powrót do strony głównej`
};

const pt_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Voltar para o início`
};

const sv_back_to_home = /** @type {(inputs: {}) => string} */ () => {
	return `Tillbaka till startsidan`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const back_to_home = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.back_to_home(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("back_to_home", locale)
	if (locale === "cs") return cs_back_to_home(inputs)
	if (locale === "da") return da_back_to_home(inputs)
	if (locale === "de") return de_back_to_home(inputs)
	if (locale === "en") return en_back_to_home(inputs)
	if (locale === "es") return es_back_to_home(inputs)
	if (locale === "fr") return fr_back_to_home(inputs)
	if (locale === "hu") return hu_back_to_home(inputs)
	if (locale === "it") return it_back_to_home(inputs)
	if (locale === "nl") return nl_back_to_home(inputs)
	if (locale === "pl") return pl_back_to_home(inputs)
	if (locale === "pt") return pt_back_to_home(inputs)
	return sv_back_to_home(inputs)
};